define('modules/start/products/landings/status/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        url: function() {
            var url = Config.backendUrl + "/details/landings";
            if (this.get('groupId')) {
                url += "/group/" + this.get('groupId');
            }
            if (this.get('companyId')) {
                url += "/company/" + this.get('companyId');
            }
            return url;
        },
        initialize: function() {
            this.initRequestEvents();
        },
        getTrialDays: function(){
            var oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
            var secondDate = new Date();
            var firstDate = new Date(this.get('endDate'));
            var days = Math.round((firstDate.getTime() - secondDate.getTime())/(oneDay));

            if (days < 0){
                return 0;
            }

            return days;
        }
    });

    module.exports = Model;
});

